/**
 * Convert Int128 to bigint
 *
 * @see https://voltaire.tevm.sh/primitives/int128 for Int128 documentation
 * @since 0.0.0
 * @param {import('./Int128Type.js').BrandedInt128} value - Int128 value
 * @returns {bigint} BigInt value
 * @example
 * ```javascript
 * import * as Int128 from './primitives/Int128/index.js';
 * const a = Int128.from(-42n);
 * Int128.toBigInt(a); // -42n
 * ```
 */
export function toBigInt(value) {
	return value;
}
